import { createElement, memo, useMemo } from "react";
import { useApp } from "../app";
import { useTranslatedTag, useTranslation } from "../localization";
const EMPTY_TAGS = [];
/**
 * Logical Discovery Tag Cloud block. Resolves the approved tag list, applies
 * NSFW eligibility, and reports selection to the host; hosts inject a view
 * that owns layout, platform primitives, and per-tag destination (identifier,
 * aria-label, etc.) resolution.
 */
const DiscoverTagCloud = ({ view, isNsfw, onTagSelect }) => {
    const { appSettings } = useApp();
    const { getTranslatedTag } = useTranslatedTag();
    const { t } = useTranslation();
    const priorityTags = appSettings?.chatbotsTags?.priority_tags ?? EMPTY_TAGS;
    const nsfwTags = appSettings?.chatbotsTags?.nsfw_tags ?? EMPTY_TAGS;
    const nsfwTagSet = useMemo(() => new Set(nsfwTags), [nsfwTags]);
    const visibleTags = useMemo(() => (isNsfw ? priorityTags : priorityTags.filter((tag) => !nsfwTagSet.has(tag))), [priorityTags, isNsfw, nsfwTagSet]);
    const items = useMemo(() => visibleTags.map((tag, position) => ({
        tag,
        label: getTranslatedTag(tag),
        position,
    })), [visibleTags, getTranslatedTag]);
    if (items.length === 0) {
        return null;
    }
    const viewProps = {
        title: t("discover:tagCloud.title", { defaultValue: "Not what you're looking for?" }),
        subtitle: t("discover:tagCloud.subtitle", { defaultValue: "Jump straight into a category." }),
        items,
        onTagSelect,
    };
    return createElement(view, viewProps);
};
export default memo(DiscoverTagCloud);
